import tw from "twin.macro";

export const Container = tw.div``;
